module.exports = __webpack_public_path__ + "static/media/white_panel.1e783833.png";